var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackOfCard = function SvgBackOfCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 43,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E4E4E4",
    fillRule: "evenodd",
    d: "M64.773 0c.922 0 1.613.22 2.305.878S68 2.413 68 3.07V39.93c0 .877-.23 1.535-.922 2.193S65.464 43 64.773 43H3.227c-.922 0-1.613-.22-2.305-.878C.231 41.684 0 40.806 0 40.148V3.071C0 2.194.23 1.536.922.878S2.536 0 3.227 0z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M68 8H0v9h68z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M52.182 11.143v.861l1.057-.406V15h.924v-4.648h-.077zm5.779 1.757c.294-.329.504-.721.504-1.162 0-.833-.595-1.386-1.512-1.386s-1.449.56-1.561 1.379l.833.14c.056-.399.287-.665.693-.665.357 0 .609.217.609.525 0 .154-.126.392-.315.623l-1.792 2.149V15h3.087v-.861h-1.624zm3.83-.371c.37-.189.602-.525.602-.91.013-.777-.617-1.267-1.422-1.267-.594 0-1.063.266-1.385.644l.503.574c.175-.224.483-.371.777-.371.336 0 .574.175.588.455.021.322-.266.588-.763.588h-.259v.707h.434c.476 0 .798.266.798.651 0 .371-.322.644-.798.644-.336 0-.602-.168-.826-.462l-.637.497c.33.525.854.805 1.505.805.994 0 1.694-.588 1.694-1.414 0-.539-.321-.959-.811-1.141"
  })));
};
export default SvgBackOfCard;